import styled from  "styled-components"

import {H3, Body} from "@irati/ui/src/Typography"
import {Select} from "@irati/ui/src/FormItem"
import ButtonBase from "@irati/ui/src/Button"

export const AvailableBalance = styled(H3)`
  color: ${({theme}) => theme.colors.brand.default};
  font-size: 45px;
  line-height: 50px;
  text-align: center;
`

export const StyledCaption = styled(Body)`
  text-align: center;
  text-transform: uppercase;
`

export const RewardOptions = styled(Select)`
  margin: 0 -15px;
`

export const Button = styled(ButtonBase)`
  margin-top: 15px;
  width: 100%;
`
